export const FORGOT_PASSWORD_VERIFICATION_CODE_REQUEST =
  'FORGOT_PASSWORD_VERIFICATION_CODE_REQUEST';
export const FORGOT_PASSWORD_VERIFICATION_CODE_SUCCESS =
  'FORGOT_PASSWORD_VERIFICATION_CODE_SUCCESS';
export const FORGOT_PASSWORD_VERIFICATION_CODE_FAILURE =
  'FORGOT_PASSWORD_VERIFICATION_CODE_FAILURE';
